import React from 'react';
import classes from "./TopGames.module.css";
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LinedSection from './LinedSection';

const TopGames = ({ games }) => {
    console.log({ games }, 'pg');
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <section className={classes.top_games_container}>
            <LinedSection />
            <section className={classes.hero_section_2}>

                <div className={classes.hero_section_three}>
                    {/* {games?.slice(5, 6)?.map((game, idx) => {
                        return (
                            // <div className={classes.hero_section_three_container}>
                            //     <h3 className={classes.hero_section_three_heading}>{t("64")} {game?.category?.category_name} {t("63")}</h3>

                            //     {game?.games.slice(0, 5)?.map((g, index) => (
                            //         <div className={classes.hero_section_three_game_container} key={index}
                            //             onClick={() => navigate("/game", {
                            //                 state: {
                            //                     game: g
                            //                 }
                            //             })}
                            //         >
                            //             <div className={classes.hero_section_three_game_image_container}>
                            //                 <img src={g?.game_banner} alt={g?.game_name} className={classes.hero_section_three_game_image} />
                            //             </div>
                            //             <div className={classes.hero_section_three_content_container}>
                            //                 <p className={classes.hero_section_three_game_name}>{g?.game_name}</p>
                            //                 <p className={classes.hero_section_three_game_desc}>{g?.description}</p>
                            //             </div>
                            //         </div>
                            //     ))}
                            // </div>
                            <div className={classes.hero_section_three_container}>
                                <h3 className={classes.hero_section_three_heading}>{t("64")} {game?.category?.category_name} {t("63")}</h3>

                                {game?.games.slice(0, 3)?.map((g, index) => (
                                    <motion.article
                                        key={index}
                                        layout
                                        whileHover={{ y: -10, scale: 1.015 }}
                                        transition={{ type: "spring", stiffness: 220, damping: 18 }}
                                        className={`${classes.game_card} ${classes.small_card}`}
                                        onClick={() => navigate("/game", {
                                            state: {
                                                game: g
                                            }
                                        })}
                                    >
                                        <div className={classes.media_wrap}>
                                            <img
                                                src={g.game_banner}
                                                alt={g.game_name}
                                                className={classes.game_image}
                                            />
                                        </div>

                                        <div className={classes.overlay_in_card} />
                                        <div className={classes.overlay_top} />
                                        <div className={classes.card_border_glow} />
                                        <div className={classes.card_shine} />

                                        <div
                                            className={`${classes.card_content} ${classes.card_content_small
                                                }`}
                                        >
                                            <div className={classes.meta_row}>
                                                <p className={classes.game_category}>{g.category_name}</p>
                                                <span className={classes.play_chip}>Play now</span>
                                            </div>

                                            <h3
                                                className={`${classes.game_name} ${classes.small_title
                                                    }`}
                                            >
                                                {g.game_name}
                                            </h3>

                                            <div className={classes.bottom_accent} />
                                        </div>
                                    </motion.article>
                                ))}
                            </div>
                        )
                    })} */}

                    <div className={classes.hero_section_three_container}>
                        <h3 className={classes.hero_section_three_heading}>{t("122")}</h3>

                        {games?.slice(0, 3)?.map((g, index) => (
                            <motion.article
                                key={index}
                                layout
                                whileHover={{ y: -10, scale: 1.015 }}
                                transition={{ type: "spring", stiffness: 220, damping: 18 }}
                                className={`${classes.game_card} ${classes.small_card}`}
                                onClick={() => navigate("/game", {
                                    state: {
                                        game: g
                                    }
                                })}
                            >
                                <div className={classes.media_wrap}>
                                    <img
                                        src={g.game_banner}
                                        alt={g.game_name}
                                        className={classes.game_image}
                                    />
                                </div>

                                <div className={classes.overlay_in_card} />
                                <div className={classes.overlay_top} />
                                <div className={classes.card_border_glow} />
                                <div className={classes.card_shine} />

                                <div
                                    className={`${classes.card_content} ${classes.card_content_small
                                        }`}
                                >
                                    <div className={classes.meta_row}>
                                        <p className={classes.game_category}>{g.category_name}</p>
                                        <span className={classes.play_chip}>Play now</span>
                                    </div>

                                    <h3
                                        className={`${classes.game_name} ${classes.small_title
                                            }`}
                                    >
                                        {g.game_name}
                                    </h3>

                                    <div className={classes.bottom_accent} />
                                </div>
                            </motion.article>
                        ))}
                    </div>

                </div>

                <div className={classes.hero_section_two_2}>
                    {/* <img src="/images/gradient.png" alt="gradient" className={classes.hero_section_two_image_2} /> */}
                    {/* <img src="/images/player.png" alt="player" className={classes.player_image_2} /> */}
                </div>

                {/* <div className={classes.hero_section_three}>
                    {games?.slice(6, 7)?.map((game, idx) => {
                        return (
                            <div className={classes.hero_section_three_container}>
                                <h3 className={classes.hero_section_three_heading}>{t("64")} {game?.category?.category_name} {t("63")}</h3>

                                {game?.games.slice(0, 5)?.map((g, index) => (
                                    <div className={classes.hero_section_three_game_container} key={index}
                                        onClick={() => navigate("/game", {
                                            state: {
                                                game: g
                                            }
                                        })}
                                    >
                                        <div className={classes.hero_section_three_game_image_container}>
                                            <img src={g?.game_banner} alt={g?.game_name} className={classes.hero_section_three_game_image} />
                                        </div>
                                        <div className={classes.hero_section_three_content_container}>
                                            <p className={classes.hero_section_three_game_name}>{g?.game_name}</p>
                                            <p className={classes.hero_section_three_game_desc}>{g?.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )
                    })}

                </div> */}

            </section>
        </section >

    )
}

export default TopGames